import axios from 'axios';

import { config } from '~/utils/constants';

export const Endpoints = {
  BASE_URL: config.BASE_URL,
  BUSCAR_DADOS: '/acionamento-clinica/acionamento/assistservico/',
  BUSCAR_STATUS: '/acionamento-clinica-status/assistservico/',
  ULTIMO_STATUS: '/acionamento-clinica-status/ultimo-status/assistservico/',
  BUSCAR_CLINICAS: '/clinica/assistservico/',
  ACEITAR_CLINICA: '/clinica/seleciona/',
  VALORES_EXCEDENTES: '/valor-servico/assistservico/',
  VALORES_EXCEDENTES_AUTORIZAR: '/valor-servico/autorizado/',
};

const api = axios.create({
  baseURL: Endpoints.BASE_URL,
  timeout: 20 * 1000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'Access-Control-Allow-Origin': '*',
  },
});

export default api;
